document.querySelectorAll('[data-hotspot-stage]').forEach((stage) => {
  const dots = stage.querySelectorAll('[data-hotspot-toggle]');
  dots.forEach((dot) => {
    dot.addEventListener('click', (e) => {
      e.stopPropagation();
      const wasOpen = dot.classList.contains('is-open');
      dots.forEach((d) => d.classList.remove('is-open'));
      if (!wasOpen) dot.classList.add('is-open');
    });
  });
  document.addEventListener('click', () => {
    dots.forEach((d) => d.classList.remove('is-open'));
  });
});